import { AxiosRequestConfig } from "axios";

import { User, UserDetailedInfo } from "@/types";

import { axios } from "../axios.instance";

export type GetMyUserRequest = AxiosRequestConfig;
export type GetMyUserResponse = User & UserDetailedInfo;

export const getMyUser = async (config?: GetMyUserRequest): Promise<GetMyUserResponse | undefined> => {
  try {
    const { data } = await axios.get("users/me", config);
    return data;
  } catch (error) {}
};
